/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei';

function TitleInnovation() {
  const { nodes, materials } = useGLTF('/models/InnovationTitle.gltf');
  return (
    <group dispose={null} rotation={[0, -1.8, 0]}>
      <group
        position={[20, 35, -13]}
        rotation={[Math.PI / 2, 0, -Math.PI / 2]}
        scale={[0.85, 0.98, 0.85]}
      >
        <mesh geometry={nodes.Cubo.geometry} material={materials['white.001']} />
        <mesh geometry={nodes.Cubo_1.geometry} material={materials.white} />
      </group>
    </group>
  );
}

useGLTF.preload('/models/InnovationTitle.gltf');

export default TitleInnovation;
